import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, ID } from '../../core/utils';
import { ManyRecipients, Recipient, RecipientToAdd } from '../models/Recipient';
import { Vehicle, VehicleToAdd, VehicleIds } from '../models/Vehicle';
import { Driver, DriverToAdd } from '../../core/models/Driver';
import { AlarmToAdd } from '../models/Alarm';
import Unit from '../models/Unit';
import { Alarm } from '../models/Alarm';
import { DeactivateParams, ParameterValue } from '../../core/models/Vehicle';
import { CompaniesService } from './CompaniesService';

export const SettingsService = {
    ...CompaniesService,
    //Drivers
    postDriver: (
        companies: any = [],
        configuration: DriverToAdd,
        mock: boolean,
        cancelToken: any
    ): Promise<DriverToAdd> =>

    //Drivers
    Http.post(`${TypeResource.DRIVERS}${EndPoints.DriversUrls.DRIVERS}`, configuration, {
        params: getParams([{ key: 'id', value: companies }])
    }).then(response => response.data),
        
    patchDriver: (id: string, configuration: DriverToAdd, mock: boolean, cancelToken: any): Promise<DriverToAdd> =>
        Http.patch(`${TypeResource.DRIVERS}${EndPoints.DriversUrls.DRIVERS}`, configuration, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getDriversList: (id: string | null, mock: boolean, cancelToken: any): Promise<Driver[]> => {
        return Http.get(`${TypeResource.DRIVERS}${EndPoints.DriversUrls.DRIVERS_LIST}` + `${id == null ? '' : '?id='+id}`).then(response => response.data);
    },

    //vehicles
    getAlarmsList: (id: string): Promise<Alarm[]> =>
        Http.get(`${TypeResource.ALARM}${EndPoints.VehicleUrls.ALARM_LIST}` + '?company_id=' + id, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getVehicleProperties: (): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.PROPERTIES}`, {}).then(response => response.data),

    getAlarmById: (id: number): Promise<any> =>
        Http.get(`${EndPoints.VehicleUrls.ALARM}`, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    postAlarm: (alarm: AlarmToAdd): Promise<any> =>
        Http.post(`${EndPoints.VehicleUrls.ALARM}`, alarm).then(response => response.data),

    patchAlarm: (alarm: AlarmToAdd, id: number): Promise<any> =>
        Http.patch(`${EndPoints.VehicleUrls.ALARM}`, alarm, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getUnit: (id: number): Promise<Unit> =>
        Http.get(`${TypeResource.NORMS}${EndPoints.VehicleUrls.UNIT}` + '?id=' + id).then(response => response.data),

    postVehicle: (vehicle: any): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}` + '/', vehicle).then(response => response.data),

    setVehicleParameterValue: (configuration: ParameterValue): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.SET_PARAMETER_VALUE}`, configuration).then(response => response.data),

    deactivateVehicleNorm: (configuration: DeactivateParams): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.DEACTIVATE_NORM}`, configuration).then(response => response.data),

    deactivateAlertsToVehicles: (configuration: DeactivateParams): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.VEHICLES_DEACTIVATE_ALERTS}`, configuration).then(response => response.data),
    
    getVehicleAlerts: (ids: number[]): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.VEHICLES_ALERTS}`, {
            params: getParams([
                {
                    key: TypeParams.IDS,
                    value: joinParams(ids, ',')
                },
            ])
        }).then(response => response.data),

    listParameterValue: (vehicleId: number): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.LIST_PARAMETER_VALUE}`, {
            params: getParams([
                {
                    key: 'id',
                    value: vehicleId
                }
            ])
        }).then(response => response.data),

    activateVehicle: (id: any): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.VEHICLES_ACTIVATE}`, id).then(response => response.data),

    getVehiclesList: (company: CompanyID, allCompanies: Boolean): Promise<Vehicle[]> =>
        Http.get(
            `${EndPoints.VehicleUrls.VEHICLES_LIST}` + `${allCompanies ? '' : '?id='}` + `${allCompanies ? '' : company}`,
            {}
        ).then(response => response.data),

    getVehiclesServiceProvider: (cancelToken: any): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.VEHICLES_SERVICE_PROVIDER_LIST}`, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    getVehicleById: (vehicle: string): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}` + '/?id=' + vehicle, {}).then(response => response.data),

    patchVehicle: (id: string, vehicle: any): Promise<any> =>
        Http.patch(`${TypeResource.VEHICLES}` + '/?id=' + id, vehicle, {}).then(response => response.data),

    deleteVehicleByID: (id: string, cancelToken: any): Promise<any> =>
        Http.delete(`${TypeResource.VEHICLES}` + '/?id=' + id, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getAlarmsListByVehicleId: (id: string): Promise<Alarm[]> =>
        Http.get(`${TypeResource.ALARM}${EndPoints.VehicleUrls.ALARM_LIST}` + '?vehicle_id=' + id, {}).then(response => response.data),

    activateMtop: (id: {id: string}): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.ACTIVATE_MTOP}`, id).then(response => response.data),

    disableMtop: (id: {id: string}): Promise<any> =>
        Http.delete(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.ACTIVATE_MTOP}`, {
            data: { id: id }
        }).then(response => response.data),

    resetLastValues: (configuration: VehicleIds): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.LAST_VALUES_RESET}`, configuration).then(response => response.data),

    deactivateConfigurations: (configuration: VehicleIds): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.CONFIGURATION_DESACTIVATE_ALL}`, configuration).then(
            response => response.data
        ),

    confirmConfigurations: (configuration: VehicleIds): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.CONFIGURATION_CONFIRM_ALL}`, configuration).then(response => response.data),

    alarmSistrac: (configuration: VehicleIds): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.ALARM_SISTRAC}`, configuration).then(response => response.data),

    changeEquipment: (vehicles: any): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.CHANGE_EQUIPMENT}`, vehicles).then(response => response.data),

    resendConfigurations: (configuration: VehicleIds): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.CONFIGURATION_RESEND}`, configuration).then(response => response.data),

    deleteDriverByID: (ids: number[], cancelToken: any): Promise<any> =>
        Http.delete(`${TypeResource.DRIVERS}${EndPoints.DriversUrls.DRIVERS}`, {
            params: getParams([{ key: 'id', value: joinParams(ids, ',') }]),
            cancelToken: cancelToken.token
        }),

    deleteAlarmByID: (id: string): Promise<any> =>
        Http.delete(`${EndPoints.VehicleUrls.ALARM}`, {
            params: getParams([{ key: 'id', value: id }])
        }).then(response => response.data),

    getSIMData: (): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.SIM_LIST}`, {}).then(response => response.data),

    exportSimData: (): Promise<any> =>
        Http.get(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.SIM_EXPORT}`, {
            responseType: 'arraybuffer'
        }).then(response => response.data),

    createSim: (phoneData: any): Promise<any> =>
        Http.post(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.SIM}`, phoneData).then(response => response.data),

    ImportExcel: (formData: any): Promise<any> =>
        Http.post<any[]>(`${TypeResource.VEHICLES}${EndPoints.VehicleUrls.SIM_IMPORT}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => response.data),

    //recipients
    getRecipientsList: (ids: ID[], mock: boolean, cancelToken: any): Promise<Recipient[]> =>
        Http.get(`${EndPoints.RecipientsUrls.RECIPIENTS_LIST}` + '?company_ids=' + ids, {
            cancelToken: cancelToken.token
        }).then(response => response.data),

    patchMultipleRecipients: (idsRecipientsWithCompaniesToAdd: ManyRecipients): Promise<any> => {
        return Http.patch(`${EndPoints.RecipientsUrls.RECIPIENTS_MANY}`, idsRecipientsWithCompaniesToAdd, );
    },

    deleteRecipientsByID: (ids: number[], cancelToken: any): Promise<any> =>
    Http.delete(`${EndPoints.RecipientsUrls.RECIPIENTS}`, {
        params: getParams([{ key: 'id', value: joinParams(ids, ',') }]),
        cancelToken: cancelToken.token
    }),

    patchRecipientByID: (recipient: RecipientToAdd, id: number): Promise<any> => {
        return Http.patch(`${EndPoints.RecipientsUrls.RECIPIENTS}`, recipient, {
            params: getParams([{ key: 'id', value: id }])
        });
    },

    postRecipient: (recipient: RecipientToAdd, company: CompanyID): Promise<Recipient> =>
    Http.post(`${EndPoints.RecipientsUrls.RECIPIENTS}` + '?id=' + company, recipient).then(
        response => response.data
    ),
};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
